import errors from './errors/index.js';
import translation from './translation/index.js';
const th = {
    translation,
    errors,
};
export default Object.freeze(th);
